import dynamic from 'next/dynamic'
import Head from 'next/head'
import { generalConstants } from '@tweddle-se-team/common/constants'

const { UG } = generalConstants

const Content = dynamic(() => import('../subaru/components/publication/publicationContents'))

const SubaruLayout = props => {
  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          href={
            props?.publicationInfo?.publicationType === UG
              ? '/styles/subaru_japan_ug_publications.css'
              : '/styles/subaru_tgus_publications.css'
          }
        />
      </Head>
      <Content {...props} />
    </>
  )
}

export default SubaruLayout
